import dynamic from "next/dynamic";
import { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import { getTransfers } from "rivals/redux/transfer/selectors";
import { useIsLgDesktopWidth } from "rivals/shared/utils/mediaQuery";
import { setData } from "rivals/shared/utils/qa";
import EndResultsCard from "./EndResultsCard";
import TransferCard from "./TransferCard";
import styles from "./index.module.scss";
import strings from "./strings";
import { OwnProps } from "./types";

const Slider = dynamic(() => import("rivals/components/shared/Slider"), {
  ssr: false
});

const { latestTransferPortalActivity } = strings;
const MAX_RESULTS_TO_SHOW_END_RESULTS_CARD = 3;

const RecentTransfers: FunctionComponent<OwnProps> = ({ data = "" }) => {
  const recentTransfers = useSelector(getTransfers);
  const matchesLgDesktop: boolean = useIsLgDesktopWidth();
  const showsEndResultsCard: boolean =
    !recentTransfers?.length ||
    recentTransfers.length <= MAX_RESULTS_TO_SHOW_END_RESULTS_CARD - 1 ||
    (recentTransfers?.length === MAX_RESULTS_TO_SHOW_END_RESULTS_CARD &&
      matchesLgDesktop);

  return (
    <div
      className={styles.wrapper}
      {...setData(data, "recent-transfers-wrapper")}
    >
      <h1 className={styles.widgetTitle}>{latestTransferPortalActivity}</h1>
      <div
        className={styles.sliderContainer}
        {...setData(data, "recent-transfers-slider-wrapper")}
      >
        <Slider className={styles.athletesActivityCarousel} shadowIndicator>
          {recentTransfers?.map((transfer, index) => (
            <TransferCard key={index} transfer={transfer} />
          ))}
          {showsEndResultsCard && (
            <EndResultsCard
              data={data}
              emptyResults={!recentTransfers?.length}
            />
          )}
        </Slider>
      </div>
    </div>
  );
};

export default RecentTransfers;
